var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgFooterBorder = function SvgFooterBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "auto",
    height: "auto",
    viewBox: "0 0 375 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8h375V1.714l-19.73 1.083-17.071-.92-23.394 2.577-23.49-1.657-14.104 1.657-12.919-2.576-27.605.919L209.084 4 185.721.974S174.471 3.19 169.5 3.19 162 .974 158.129.974c-3.87 0-25.583 3.895-25.583 3.895l-24.172-.868H85.715L41.919 0 15.85 2.797 0 1.714V8Z",
    fill: "#000"
  })));
};

export default SvgFooterBorder;